"use client"

import * as React from "react"
import { cn } from '../../lib/utils'

/**
 * @note ref is typed as HTMLDivElement. When using `as` prop with other elements,
 * cast the ref if you need element-specific methods.
 */
export interface UIBoxProps extends React.HTMLAttributes<HTMLElement> {
  as?: React.ElementType
}

export const UIBox = React.forwardRef<HTMLDivElement, UIBoxProps>(
  ({ className, as: Component = "div", ...props }, ref) => {
    return (
      <Component
        ref={ref}
        className={cn(className)}
        {...props}
      />
    )
  }
)

UIBox.displayName = "UIBox"